<template>
	<div class="challenge" :class="{active: lastBehavior}">
		<div class="challenge-inner">
			<div class="challenge-inner-days" v-if="days"><span v-html="__('card_challenge_top_challenge')"></span> {{ days }} <span v-html="__('card_challenge_top_days')"></span></div>

			<div class="challenge-inner-content">
				<div v-if="state === 'init'">
					<div class="challenge-inner-content-social" v-if="card.totalAccept !== null">
						<img src="@/assets/img/check.png" width="13"> <strong>{{ card.totalAccept }}</strong> {{ $processText(card.type_options.social_norm_text) }}
						<br><strong v-html="__('card_challenge_can_you_do_it')"></strong>
					</div>

					<h3 class="challenge-inner-content-top">{{ $processText(card.title) }}</h3>

					<div class="challenge-inner-content-btn" @click="accept()" v-html="__('card_challenge_button_accept')"></div>

					<p class="challenge-inner-content-desc" v-html="$processText(card.wysiwyg)"></p>
				</div>

				<div v-if="state === 'challenge'">
					<h3 class="challenge-inner-content-top">{{ $processText(card.title) }}</h3>

					<div class="challenge-inner-content-btn" @click="finish()">
						<span v-html="__('card_challenge_button_mark_as_done')"></span> <i class="fas fa-check"></i>
					</div>

					<p class="challenge-inner-content-desc">
						{{ __('challenge_friskt_vagat_1', 'Friskt vågat! Du har') }} {{ days }} {{ __('challenge_friskt_vagat_2', 'dagar på dig. Rapportera tillbaka när du klarat det.') }}
						<span v-html="$processText(card.wysiwyg)"></span>
					</p>
				</div>

				<div v-if="state === 'finished'">
					<h3 class="challenge-inner-content-small-top"><span v-html="__('card_challenge_done_challenge')"></span> "{{ card.title }}" <span v-html="__('card_challenge_done_done')"></span></h3>
					<h3 class="challenge-inner-content-top" v-html="__('card_challenge_well_done')"></h3>

					<img class="mb-3" src="@/assets/img/pokal.png" width="124">

					<p class="challenge-inner-content-desc" v-html="$processText(card.wysiwyg)"></p>

					<div class="challenge-inner-content-btn reset" @click="reset()">
						<span v-html="__('card_challenge_button_redo')"></span> <i class="fas fa-chevron-right"></i>
					</div>
				</div>
			</div>

			<div class="challenge-inner-bg"></div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'Challenge',
    props: ['card'],

    data() {
    	return {
    		state: 'init',
			started_at: null
    	}
    },

	watch: {
		lastBehavior: {
			immediate: true,
			handler: function(n, o) {
				if (n && (! o || n.id !== o.id)) {
					if (n.title === 'Finished') { 
						this.state = 'finished' 
						this.card.finished = true
						this.card.accepted = false
					}

					if (n.title === 'Accepted') { 
						this.state = 'challenge' 
						this.card.accepted = true
					}
				}
			}
		}
	},

    methods: {
    	accept() {
    		this.state = 'challenge'

			this.$store.commit('registerBehavior', {
				title: 'Accepted',
				card_id: this.card.id,
				end_user_id: this.$store.state.endUser.id
			})

			setTimeout(() => this.$store.state.sideProfileOpen = true, 1000)

			this.$metric({'event': 'challenge_interaction', 'InteractionType': 'started', 'ChallengeName': this.card.title})
    	},

    	finish() {
			this.state = 'finished'
			this.$store.state.remindChallenge = false

			setTimeout(() => this.$store.state.sideProfileOpen = true, 1000)

			this.$store.commit('registerBehavior', {
				title: 'Finished',
				card_id: this.card.id,
				end_user_id: this.$store.state.endUser.id
			})

			this.$metric({'event': 'challenge_interaction', 'InteractionType': 'completed', 'ChallengeName': this.card.title})
    	},

    	reset() {
			this.accept()
    	},
    },

    computed: {
    	days() {
    		return this.card.type_options.challenge_days
    	},

    	lastBehavior() {
    		if ( ! this.$store.state.endUser) {
    			return null
    		}

    		let behaviors = this.$store.state.endUser.behaviors
    			.filter(b => b.card_id === this.card.id)
    			.reverse()

    		return behaviors.length > 0 ? behaviors[0] : null
    	}
    }
}
</script>